interface AppMessageScreenProps {
  title: string;
  message: string;
  details?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function AppMessageScreen({
  title,
  message,
  details,
  actionLabel,
  onAction,
}: AppMessageScreenProps) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", system-ui, sans-serif',
        padding: "2rem",
        textAlign: "center",
      }}
    >
      <h1 style={{ fontSize: "1.5rem", marginBottom: "0.5rem" }}>{title}</h1>
      <p style={{ color: "#666", marginBottom: details ? "0.75rem" : "1.5rem", maxWidth: "32rem" }}>
        {message}
      </p>
      {details ? (
        <p style={{ color: "#888", marginBottom: "1.5rem", maxWidth: "36rem", fontSize: "0.875rem" }}>
          {details}
        </p>
      ) : null}
      {actionLabel && onAction ? (
        <button
          onClick={onAction}
          style={{
            padding: "0.5rem 1.5rem",
            borderRadius: "0.375rem",
            border: "1px solid #ccc",
            background: "#fff",
            cursor: "pointer",
            fontSize: "0.875rem",
          }}
        >
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
}
